import { useEffect } from "react";
import { DyteProvider, useDyteClient } from "@dytesdk/react-web-core";
import { useSearchParams } from "react-router-dom";

import { getUserAuthTokenForMeeting } from "../../data/appointments";
import Meeting from "./meeting-components/Meeting";

export function Session() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("sessionId") || "";

  if (!sessionId) {
    throw new Error("Session ID is required");
  }

  const [meeting, initMeeting] = useDyteClient();

  useEffect(() => {
    async function initalizeMeeting() {
      const authToken = await getUserAuthTokenForMeeting(sessionId, "mentee");

      if (!authToken) {
        alert(
          "An authToken wasn't passed, please pass an authToken in the URL query to join a meeting."
        );
        return;
      }

      const meeting = await initMeeting({
        authToken,
        defaults: {
          audio: false,
          video: false,
        },
      });

      await meeting!.joinRoom();
    }

    if (!meeting) {
      initalizeMeeting();
    }
  }, [meeting]);

  return (
    <DyteProvider value={meeting}>
      <Meeting sessionId={sessionId} />
    </DyteProvider>
  );
}
